import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import Helmet from 'react-helmet'

import data from '../data/data.json'
import './App.css'

import Header from '../Header/Header.js'
import Footer from '../Footer/Footer.js'
import Home from '../Home/Home.js'
import NoMatch from '../NoMatch.js'
import Contact from '../Contact/Contact.js'
import Gallery from '../Shop/Gallery.js'
import ProductSingle from '../Shop/ProductSingle.js'
import ScrollToTop from '../ScrollToTop.js'

class App extends Component {
  state = {
    data
  }

  getDocument = (collection, name) =>
    this.state.data[collection] && this.state.data[collection].filter(page => page.name === name)[0]

  componentWillMount () {
    import('../netlifyIdentity')
  }

  render () {
    const { gallery } = this.state.data
    const homePage = this.getDocument('pages', 'home')
    return (
      <Router>
        <div className='App'>
          <ScrollToTop />
          <Helmet
            titleTemplate={`${homePage.siteTitle} | %s`}
            meta={[ { name: 'description', content: homePage.story } ]}
          />
          <Header logo={homePage.logo} title={homePage.siteTitle} etsy={homePage.etsy} instagram={homePage.instagram} />
          <Switch>
            <Route exact path='/' render={(router) => <Home router={router} page={homePage} galleryItems={gallery} />} />
            <Route path='/contact/' render={(router) => <Contact router={router} etsy={homePage.etsy} instagram={homePage.instagram} />} />
            <Route exact path='/gallery/' render={(router) => <Gallery router={router} galleryItems={gallery} />} />
            <Route path='/gallery/:id/' render={(router) => <ProductSingle router={router} galleryItems={gallery} />} />
            <Route component={NoMatch} />
          </Switch>
          <Footer />
        </div>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App/App.js